module.exports = __webpack_public_path__ + "media/images/wedding/top/img_wedding-fc2382bb9806446e5ead954c98e6334e.jpg";